/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
// react library for routing
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "@fullcalendar/common/main.min.css";
import "@fullcalendar/daygrid/main.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "select2/dist/css/select2.min.css";
import "quill/dist/quill.core.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// plugins styles downloaded
import "assets/vendor/nucleo/css/nucleo.css";
// core styles
import "assets/scss/argon-dashboard-pro-react.scss?v1.2.0";

import AdminLayout from "layouts/Admin.js";
import RTLLayout from "layouts/RTL.js";
import AuthLayout from "layouts/Auth.js";
import IndexView from "views/Index.js";
import { AuthProvider } from "contexts/AuthContext";
import { StaticDataProvider } from "contexts/StaticDataContext";

// Suprime o overlay do webpack dev server para ResizeObserver (falso positivo comum em tabelas virtuais)
// Deve ser executado logo no início, mas após os imports (exigência do ESLint)
if (process.env.NODE_ENV === 'development') {
  const ignoredErrors = [
    'ResizeObserver loop completed with undelivered notifications',
    'ResizeObserver loop limit exceeded',
  ];

  const shouldIgnore = (message) => {
    if (!message) return false;
    const msgString = String(message);
    return ignoredErrors.some((err) => msgString.includes(err));
  };

  // 1. Console.error (onde o Webpack costuma capturar)
  const originalError = window.console.error;
  window.console.error = (...args) => {
    if (args.some(shouldIgnore)) return;
    originalError.apply(window.console, args);
  };

  // 2. Evento global de erro
  window.addEventListener('error', (e) => {
    if (shouldIgnore(e.message) || shouldIgnore(e.error?.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });

  // 3. window.onerror
  const _onerror = window.onerror;
  window.onerror = (msg, ...args) => {
    if (shouldIgnore(msg)) return true;
    return _onerror ? _onerror(msg, ...args) : false;
  };
}


ReactDOM.render(
  <AuthProvider>
    <StaticDataProvider>
      <BrowserRouter>
        <Suspense fallback={<div className="py-5 text-center">Carregando...</div>}>
          <Switch>
            <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
            <Route path="/rtl" render={(props) => <RTLLayout {...props} />} />
            <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
            <Route path="/" render={(props) => <IndexView {...props} />} />
            <Redirect from="*" to="/admin" />
          </Switch>
        </Suspense>
      </BrowserRouter>
    </StaticDataProvider>
  </AuthProvider>,
  document.getElementById("root"),
);
